import { Box, Drawer, ExpandableSection, Header, KeyValuePairs, SpaceBetween, SplitPanel } from '@cloudscape-design/components';
import React, { useState } from 'react';
import { useGlobalState } from "../../pages/context/GlobalStateContext";
import { ItemUser } from '../../resources/types';
const _preserve = React.version;


interface SidePanelUserProps {
    user: Partial<ItemUser>;
    edit?: boolean;
}

const SidePanelUser: React.FC<SidePanelUserProps> = ({
    user,
    edit = false,
}) => {

    const [showImageModal, setShowImageModal] = useState(false);
    const { data } = useGlobalState();


    return (

        <>
            <SplitPanel hidePreferencesButton header={`Detalle de usuario`} closeBehavior='hide'>
                {!!user && (
                    <SpaceBetween direction='vertical' size='m'>
                        <Drawer header={<h2>{user.lastName}, {user.name}</h2>}>
                            <Box margin={{ bottom: "l" }}>
                                <SpaceBetween size="xxl">
                                    <SpaceBetween size="xs">
                                        <Header variant="h3">
                                            Fecha de ingreso: {user.dateMember}
                                        </Header>
                                        <ExpandableSection
                                            headerText="Cargos"
                                            defaultExpanded
                                        >
                                            <KeyValuePairs
                                                columns={2}
                                                items={
                                                    user?.charges?.map((charge, index) => ({
                                                        label: charge.charge,
                                                        value: charge.accountPlan
                                                    }))
                                                }
                                            />
                                        </ExpandableSection>
                                    </SpaceBetween>

                                </SpaceBetween>
                            </Box>
                        </Drawer>
                    </SpaceBetween>
                )}
            </SplitPanel >

        </>
    );
};

export default SidePanelUser;